
import React, { useEffect } from 'react';

const DownloadApp = () => {

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.vlv&hl=en';
        const APP_STORE_URL = 'https://apps.apple.com/am/app/vlv-centre/id6476923086';
        const FALLBACK_URL = 'https://vlv.am';
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.location.href = APP_STORE_URL;
            return;
        }
        if (/android/i.test(userAgent)) {
            window.location.href = GOOGLE_PLAY_URL;
            return;
        }
        window.location.href = FALLBACK_URL;
    }, []);

    return (
        <div style = {{ padding: '2rem', textAlign: 'center' }}>
            <p>Перенаправление в магазин приложений...</p>
        </div>
    );
};

export default DownloadApp;
